<template>
  <div class="source-drawer__content">
    <p class="source-drawer__title">
      {{$t('feed.settings.source.newSource.title')}}
    </p>

    <p>{{$t('feed.settings.source.newSource.description[0]')}}.</p>
    <p>{{$t('feed.settings.source.newSource.description[1]')}}:</p>

    <ul class="networks-list">
      <li class="networks-list__item" v-for="(network, index) in networks" :key="index">
        <b>{{network.name === 'GlobalSearch' ? $t('feed.settings.source.newSource.gsm') : network.name}}</b>
        <ul class="network-source-list">
          <li class="network-source-list__item" v-for="source in getSourceByName(network.name)" :key="source.name">
            {{source.name}}
          </li>
        </ul>
      </li>
    </ul>
    <el-divider></el-divider>

    <el-form :model="sourceForm" :rules="rules" ref="sourceForm" label-width="120px" class="demo-ruleForm" v-loading="loading">
      <el-form-item label="Источники" prop="network_list">
        <el-input size="small" type="textarea" v-model="sourceForm.network_list"></el-input>
      </el-form-item>

      <el-divider></el-divider>

      <div class="user-footer">
        <el-button
          size="medium"
          type="primary"
          @click="handleAdd('sourceForm')">{{$t('feed.settings.source.newSource.form.addButton')}}</el-button>
        <el-button
          size="medium"
          @click="resetForm('sourceForm')">{{$t('feed.settings.source.newSource.form.cancelButton')}}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  /*
    New source component
  */

  // components
  import notify from "../../../../../../helpers/notify";

  // api
  import { getNetworks } from "../../../../../../api/network";
  import { addSourcesApi, getSourcesApi } from "../../../../../../api/feeds";

  export default {
    name: 'NewSource',
    data() {
      return {
        networksTypes: this.$t('feed.settings.source.newSource.networksTypes'),
        networks: [],
        offset: 0,
        limit: 120,
        loading: false,
        sourceForm: {
          network_list: '',
        },
        sources: [],
        rules: {
          network_list: [
            { required: true, message: this.$t('feed.settings.source.newSource.rules'), trigger: 'blur'  },
          ],
        },
      };
    },
    methods: {
      getSourceByName(name) {
        return this.networksTypes[name];
      },
      handleAdd(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;

            let params = {
              thread_id: this.$route.params.threadId,
              profiles: this.sourceForm.network_list,
            };

            addSourcesApi(params).then(resp => {
              notify.call(this, this.$t('feed.settings.source.newSource.notify.add'), "success");
              this.$refs[formName].resetFields();
              this.loading = false;
              this.updateSources(resp.data);
              this.getSources()
            });
          } else {
            this.loading = false;
            notify.call(this, this.$t('feed.settings.source.newSource.notify.error'), "error");
            return false;
          }
          
        });
      },
      updateSources(source) {
        this.$emit('updateSources');
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    mounted() {
      getNetworks().then(resp => {
        this.networks = resp.data.filter(item => !['GlobalSearch', 'Telegram', 'TikTok'].includes(item.name));
      });
    }
  };
</script>

<style>
  .source-drawer__content {
    margin: 0 15px 0 15px;
    font-family: "Roboto", "Arial", sans-serif;
  }
  .source-drawer__title {
    padding: 0;
    margin: 0;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 14px;
    color: #5E6D82;
  }
  .networks-list {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .source-list {
    padding: 0;
    margin: 0;
    list-style: none;
  }
</style>
